<rt-select
  [formControl]="input.control"
  [options]="resourceSelectOptions"
  [hasSearch]="input.hasSearch"
  [includeEmptyOption]="input.includeEmptyOption"
  [placeholder]="selectPlaceholder"
  [optionTemplate]="optionTemplate"
/>

<ng-template #optionTemplate let-option="option">
  <div layout-horizontal layout-align-items-center>
    <rt-avatar
      [imageSrc]="option.photoThumbUrl"
      [type]="option.hasAvatar ? 'image' : 'initials'"
      [initials]="option.initials"
      size="small-x"
      shape="oval"
      margin-right-small-x
      context="admin"
    />
    <span>{{ option.label }}</span>
  </div>
</ng-template>
